module.exports = __webpack_public_path__ + "img/device-default.b6fdd053.png";